export default "__VITE_ASSET__BlnJ85fV__"